module.exports = __webpack_public_path__ + "static/img/left-door-wall-steel_256.9a60b11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/left-door-wall-steel_256.png
// module id = 4jUq
// module chunks = 0